<template>
  <div id="statement" v-if="statement">
    <div class="inner">
      <span @click="closeStatement" class="closeStatement"><img src="@img/statement/close.png"></span>
      <img class="pc-popup" src="@img/popup/fake-popup-PC-2.png" alt="pc">
      <img class="mb-popup" src="@img/popup/fake-popup-MB-2-2.png" alt="mb">
      <!-- <div class="innerHeader">
        {{$t('lang_Statement_title')}}
      </div>
      <div class="innerBody">
        <div class="fakeCover">
          <img src="@img/statement/img1.png">
          <img src="@img/statement/img2.png">
        </div>
        <div class="fakecaveat"><span><img src="@img/statement/caveat.png"></span><span>{{$t('lang_Statement_caveat')}}</span></div>
        <div class="statementContent">
          <div class="logo"><img src="@img/statement/logo.png"></div>
          <div class="statementContentInner">
            <span v-html="$t('lang_Statement_content_1')"></span>
            <span v-html="$t('lang_Statement_content_2')"></span>
          </div>
        </div>
        <div class="statementUrl">{{$t('lang_Statement_url')}}</div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'statement',
  data() {
    return {
      statement: false,
    }
  },
  methods: {
    getStatement() {
      if(!this.$cookie.get('rbStatement')){
        this.statement = true
        this.$cookie.set('rbStatement',"show",{ expires: '12h' })
      }
    },
    closeStatement() {
      this.statement = false
    },
  },
  mounted() {
    this.getStatement()
  },
}
</script>

<style lang="sass">
  @import '@css/statement.sass'
</style>
